module.exports = __webpack_public_path__ + "img/wbc-banner-clean.6f642314.jpg";